<template>
  <Toast />
  <ConfirmDialog group="headless">
    <template #container="{ message, acceptCallback, rejectCallback }">
      <div class="flex flex-col items-center p-8 bg-surface-0 dark:bg-surface-900 rounded">
        <div
          class="rounded-full bg-white outline outline-black inline-flex justify-center items-center h-24 w-24 -mt-20">
          <i class="pi pi-question text-5xl"></i>
        </div>
        <span class="font-bold text-2xl block mb-2 mt-6">{{ message.header }}</span>
        <p class="mb-0">{{ message.message }}</p>
        <div class="flex items-center gap-2 mt-6">
          <Button :label="message.rejectLabel" outlined @click="rejectCallback" class="w-32"></Button>
          <Button :label="message.acceptLabel" @click="acceptCallback" class="w-32"></Button>
        </div>
      </div>
    </template>
  </ConfirmDialog>
  <ModalStockOpnameDetail v-if="modalShowStockOpnameDetail" @closeModal="closeModal"
    :stockOpnameDetail="selectedStockOpnameDetail" :parentItemId="$route.params?.id" />
  <IndexView />
  <div id="overlay" class="fixed inset-0 bg-black bg-opacity-30 z-30" :class="{ hidden: !isBlur }"></div>
  <ViewContainer>
    <section class="p-6">
      <BackButton class="mb-5" to_url="/stock-opname" />
      <PageTitle title="Edit Stok Opname" />
      <div
        class="bg-white dark:bg-dark-900 w-full rounded-lg py-6 px-5 shadow-lg shadow-light-100 dark:shadow-dark-500">
        <InputText type="text" v-model="stockOpname.label_type" id="item-price" label="Tipe" input_class="w-full"
          disable_input="true" />
        <div id="table-header" class="mb-5 mt-5 flex justify-between">
        </div>

        <div class="overflow-x-auto">
          <div class="inline-block min-w-full align-middle">
            <div class="overflow-hidden shadow-lg rounded-lg">
              <TableComponent>
                <TableHead>
                  <TableRow>
                    <TableHeadCell>No</TableHeadCell>
                    <TableHeadCell>Kode Item</TableHeadCell>
                    <TableHeadCell>Nama Item</TableHeadCell>
                    <TableHeadCell>Stok Saat Ini</TableHeadCell>
                    <TableHeadCell>Qty</TableHeadCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow v-if="stockOpnameDetails?.length == 0">
                    <TableCell colspan="7" customClass="text-center italic text-gray-400 dark:text-gray-500"
                      noTextColor>
                      Belum ada data
                    </TableCell>
                  </TableRow>
                  <TableRow v-else v-for="(stockOpnameDetail, index) in stockOpnameDetails" :key="stockOpnameDetail.id"
                    :index="index" isBody>
                    <TableCell>{{ index + 1 }}</TableCell>
                    <TableCell>{{ stockOpnameDetail.items?.code }}</TableCell>
                    <TableCell>{{ stockOpnameDetail.items?.name }}</TableCell>
                    <TableCell>{{ allItems.find(item => item.id == stockOpnameDetail.item_id)?.stockMovements?.[0]?.closing_balance }}</TableCell>
                    <TableCell>{{ stockOpnameDetail.qty }}</TableCell>
                  </TableRow>
                </TableBody>
              </TableComponent>
            </div>
          </div>
        </div>
        <div class="flex justify-center" v-if="stockOpname.status == 'paid'">
          Sudah Diposting
        </div>
      </div>
    </section>
  </ViewContainer>
</template>

<script>
import IndexView from '@/views/IndexView.vue';
import PageTitle from '@/components/PageTitle.vue';
import BackButton from '@/components/buttons/BackButton.vue';
import InputText from '@/components/form/InputText.vue';
import { mapActions, mapGetters } from 'vuex';
import { Button, ConfirmDialog, Toast } from "primevue";
import {
  TableComponent,
  TableHead,
  TableRow,
  TableHeadCell,
  TableBody,
  TableCell,
} from "@/components/table";
import ModalStockOpnameDetail from '@/components/modals/ModalStockOpnameDetail.vue';
import ViewContainer from '@/components/ViewContainer.vue';

export default {
  name: "AddEditCustomer",
  props: ['id'],
  components: {
    IndexView, PageTitle, BackButton, Button, ConfirmDialog, Toast,
    TableComponent, TableHead, TableRow, TableHeadCell, TableBody, TableCell,
    ModalStockOpnameDetail, InputText, ViewContainer
  },
  data() {
    return {
      stockOpname: {
        form_type: null,
      },
      stockOpnameDetails: [],
      isEdit: false,
      validation: {
        form_type: {
          valid: true,
          message: ''
        },
      },

      modalShowStockOpnameDetail: false,
      isBlur: false,
      selectedStockOpnameDetail: null,
    }
  },
  async created() {
    this.fetchStockOpname();
    this.fetchStockOpnameDetails();
    this.$store.dispatch('items/fetchItems');
  },
  computed: {
    ...mapGetters('items', ['allItems']),
  },
  methods: {
    ...mapActions('stock_opnames', ['createStockOpname', 'closeStockOpname']),
    ...mapActions('stock_opname_details', ['deleteStockOpnameDetailById']),
    async fetchStockOpname() {
      const response = await this.$store.dispatch('stock_opnames/fetchStockOpnameById', this.$route.params.id);
      this.stockOpname = response.data;
      this.stockOpname.label_type = this.stockOpname.form_type == 'common' ? 'Stock Opname' : 'Lain-lain';
    },
    async fetchStockOpnameDetails() {
      const response = await this.$store.dispatch('stock_opname_details/fetchStockOpnameDetails', { stock_opname_id: this.$route.params.id, limit: 1000 });
      if (response) {
        this.stockOpnameDetails = response.data;
      } else {
        this.stockOpnameDetails = [];
      }
    },
    submitStockOpname() {
      this.$confirm.require({
        group: 'headless',
        header: 'Apakah anda yakin ingin membuat draft stok opname?',
        message: 'Silahkan konfirmasi sebelum diproses.',
        acceptLabel: 'Ya',
        rejectLabel: 'Tidak',
        accept: () => {
          this.postStockOpname();
        },
        reject: () => {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'Kamu telah membatalkan draft stok opname', life: 3000 });
        }
      });
    },
    async postStockOpname() {
      try {
        const stockOpnameData = {
          form_type: this.formType,
        };

        await this.updateStockOpname(stockOpnameData);
        await this.fetchStockOpname();

        // if (this.isEdit && this.stockOpname) {
        //   stockOpnameData.id = this.stockOpname.id;
        //   await this.updateStockOpname(stockOpnameData);
        // }
        // else {
        //   await this.createStockOpname(stockOpnameData);
        // }

        await this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Draft Stock Opname telah dibuat', life: 5000 });
      }
      catch (error) {
        console.error('Failed to save stock opname:', error);

        if (error.status === 400 && error.response.data.errors) {
          this.validationErrors(error.response.data.errors);
          this.$toast.add({ severity: 'error', summary: 'Failed', detail: error.response.data.message, life: 5000 });
        }
        else {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: error.response.data.message, life: 5000 });
        }
      }
    },
    submitCloseStockOpname() {
      this.$confirm.require({
        group: 'headless',
        header: 'Apakah anda yakin ingin posting stok opname?',
        message: 'Silahkan konfirmasi sebelum diproses.',
        acceptLabel: 'Ya',
        rejectLabel: 'Tidak',
        accept: () => {
          this.postCloseStockOpname();
        },
        reject: () => {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'Kamu telah membatalkan posting stok opname', life: 3000 });
        }
      });
    },
    async postCloseStockOpname() {
      try {
        const stockOpnameData = {
          transaction_id: this.$route.params.id,
        };

        await this.closeStockOpname(stockOpnameData);
        await this.fetchStockOpname();

        // if (this.isEdit && this.stockOpname) {
        //   stockOpnameData.id = this.stockOpname.id;
        //   await this.updateStockOpname(stockOpnameData);
        // }
        // else {
        //   await this.createStockOpname(stockOpnameData);
        // }

        await this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Draft Stock Opname telah dibuat', life: 5000 });
      }
      catch (error) {
        console.error('Failed to save stock opname:', error);

        if (error.status === 400 && error.response.data.errors) {
          this.validationErrors(error.response.data.errors);
          this.$toast.add({ severity: 'error', summary: 'Failed', detail: error.response.data.message, life: 5000 });
        }
        else {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: error.response.data.message, life: 5000 });
        }
      }
    },

    editStockOpnameDetail(stockOpnameDetail) {
      this.selectedStockOpnameDetail = stockOpnameDetail;
      this.modalShowStockOpnameDetail = true;
      this.isBlur = true;
    },
    async deleteStockOpnameDetail(table) {
      this.$confirm.require({
        group: 'headless',
        header: 'Apakah anda yakin ingin menghapus detail?',
        message: 'Silahkan konfirmasi sebelum diproses.',
        acceptLabel: 'Ya',
        rejectLabel: 'Tidak',
        accept: async () => {
          try {
            await this.deleteStockOpnameDetailById(table.id);
            this.fetchStockOpnameDetails();
            this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Berhasil menghapus detail', life: 3000 });
          }
          catch (error) {
            console.error('Gagal menghapus detail', error);
            this.$toast.add({ severity: 'error', summary: 'Failed', detail: 'Gagal menghapus detail', life: 3000 });
          }
        },
        reject: () => {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'Batal menghapus detail', life: 3000 });
        }
      });
    },

    validationErrors(errorMessage) {
      for (let index = 0; index < this.field.length; index++) {
        this.validation[this.field[index]].valid = true;
        this.validation[this.field[index]].message = '';
      }

      errorMessage.forEach((error) => {
        if (this.validation[error.field]) {
          this.validation[error.field].valid = false;
          this.validation[error.field].message = error.message;
        }
      });
    },

    showModal() {
      this.modalShowStockOpnameDetail = true;
      this.isBlur = true;
      this.selectedStockOpnameDetail = null;
    },
    closeModal() {
      setTimeout(() => {
        this.modalShowStockOpnameDetail = false;
        this.isBlur = false;
        this.fetchStockOpnameDetails();
      }, 200);
    },
  },
}
</script>